import { parseHousePickAiResponseText } from "./housePickParseAiResults";

/** Ask the model for a full batch; UI shows one page at a time via "Run it back!". */
export const HOUSE_PICK_AI_RESULT_COUNT = 12;
export const HOUSE_PICK_PAGE_SIZE = 3;

/**
 * @param {{
 *   selectedOptions?: string[],
 *   userLatitude?: number|null,
 *   userLongitude?: number|null,
 *   userVisitedRestaurants?: Array<{ name?: string }>,
 *   friendsVisitedRestaurants?: Array<{ name?: string }|string>,
 *   previouslyReturnedRestaurants?: string[],
 * }} args
 */
export function buildHousePickPrompt({
  selectedOptions = [],
  userLatitude,
  userLongitude,
  userVisitedRestaurants,
  friendsVisitedRestaurants,
  previouslyReturnedRestaurants,
}) {
  let prompt = "I am looking for a restaurant.";
  prompt += `Given the following traits: ${(selectedOptions || []).join(", ")}.`;
  prompt += `Here are the coordinates for where I am at right now: latitude ${userLatitude}, longitude ${userLongitude}.`;
  if (userVisitedRestaurants?.length > 0) {
    prompt += `I have been to the following restaurants: ${userVisitedRestaurants.map((r) => r.name).join(", ")}.`;
  }
  if (friendsVisitedRestaurants?.length > 0) {
    prompt += `My friends have been to the following restaurants: ${friendsVisitedRestaurants
      .map((r) => (typeof r === "string" ? r : r?.name))
      .filter(Boolean)
      .join(", ")}.`;
  }
  if (previouslyReturnedRestaurants?.length > 0) {
    prompt += `You already returned the following restaurants in prior "Run it back" results: ${previouslyReturnedRestaurants.join(", ")}.`;
    prompt += " Prioritize new options that have not been returned yet unless there are no better matches.";
  }
  prompt += "Please take a close look at the traits I have provided and use them to research restaurants that might be a good fit.";
  prompt += "I may have also added restaurants that I have been to and ones that my friends have been to. Please research those restaurants as well and see if they are applicable. If so, then feel free to suggest them.";
  prompt +=
    `Reply with only a JSON array of exactly ${HOUSE_PICK_AI_RESULT_COUNT} objects, not enclosed in a code block, no other text. Each object must have: "name" (restaurant name), "description" (one short sentence why it's a good fit), "address" (verified full street address; use empty string if unknown and never invent or guess), "coordinates" (latitude and longitude of the restaurant), "phone" (display phone number, or empty string if unknown), "website" (full URL including https, or empty string if unknown), "hours" (JSON array: use [] if unknown; otherwise an array of objects, each with "days" (short label like "Mon–Fri" or "Sunday") and "times" (hours for that span, e.g. "11:00 AM – 10:00 PM"). Merge consecutive days that share the same hours into one object when possible).`;
  return prompt;
}

/** @param {unknown} text */
export function parseHousePickPool(text) {
  return parseHousePickAiResponseText(text);
}
